import { z } from 'zod';
import { consolidationProfileSourceSchema } from './consolidation.js';
// Contact and address are single units: a street from one record and a city from the other is an address that
// never existed.
export const consolidationMergeFieldSchema = z.enum([
    'companyName',
    'contact',
    'numberOfEmployees',
    'address',
    'website',
    'billingAddress',
]);
export const CONSOLIDATION_MERGE_FIELDS = consolidationMergeFieldSchema.options;
// Only what the assignee decided; an untouched field follows getDefaultConsolidationMergeSource.
export const consolidationMergeResolutionSchema = z.partialRecord(consolidationMergeFieldSchema, consolidationProfileSourceSchema);
const isEmptyValue = (value) => {
    if (value === null) {
        return true;
    }
    if (typeof value === 'string') {
        return value.trim().length === 0;
    }
    return Object.values(value).every((part) => part === null || String(part).trim().length === 0);
};
export const hasConsolidationMergeValue = (profile, field) => !isEmptyValue(profile[field]);
// The partner wins, except where it holds nothing. Equality is never asked: an employee bracket against a free-text
// count, or one address line against a split street and number, are not comparable. Emptiness is.
export const getDefaultConsolidationMergeSource = (field, partner, application) => !hasConsolidationMergeValue(partner, field) && hasConsolidationMergeValue(application, field)
    ? 'OnboardingApplication'
    : 'Partner';
export const resolveConsolidationMergeSource = (field, resolution, partner, application) => resolution?.[field] ?? getDefaultConsolidationMergeSource(field, partner, application);
